import React from "react"
import SEO from "../components/seo"
import Layout from '../containers/layout/layout'
import Header from '../containers/layout/header/header-five'
import Footer from '../containers/layout/footer/footer-one'
import PageHeader from '../components/pageheader'
import ManagementArea from '../containers/management/management-area'
import ContactArea from '../containers/global/contact-area/contact-two'

const ManagementPage = ({ pageContext, location }) => (
  <Layout location={location}>
    <SEO title="Management" />
    <Header/>
    <PageHeader 
        pageContext={pageContext} 
        location={location}
        title="Management"
    />
    <main className="site-wrapper-reveal">
        <ManagementArea/>
        <ContactArea/>
    </main>
    <Footer/>
  </Layout>
)
 
export default ManagementPage
 